import "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/swap-form/i18n/fr.ts
var fr_default = {
  "widgets.swap-form.header.swap": "\xC9changer",
  "widgets.swap-form.input.title.you_pay": "Vous payez",
  "widgets.swap-form.input.title.you_receive": "Vous recevez",
  "widgets.swap-form.input.balance.balance": "Solde",
  "widgets.swap-form.fusion-info.slippage-tolerance": "Tol\xE9rance au glissement",
  "widgets.swap-form.fusion-info.auction-time": "Temps de l'ench\xE8re",
  "widgets.swap-form.fusion-info.min-receive": "R\xE9ception minimale",
  "widgets.swap-form.fusion-info.net-fee": "Frais de r\xE9seau",
  "widgets.swap-form.swap-button.confirm-swap": "Confirmer l'\xE9change",
  "widgets.swap-form.swap-button.update-swap-data": "Recherche de chemin d'\xE9change",
  "widgets.swap-form.swap-button.check-allowance": "V\xE9rifier l'allocation",
  "widgets.swap-form.swap-button.native-token-not-supported": "Le jeton natif n'est pas support\xE9 actuellement",
  "widgets.swap-form.swap-button.approve-and-swap": "Approuver et \xE9changer",
  "widgets.swap-form.swap-button.permit-and-swap": "Permettre et \xE9changer",
  "widgets.swap-form.swap-button.connect-wallet": "Connecter le portefeuille",
  "widgets.swap-form.swap-button.select-source-token": "S\xE9lectionner le jeton source",
  "widgets.swap-form.swap-button.select-destination-token": "S\xE9lectionner le jeton de destination",
  "widgets.swap-form.swap-button.enter-amount-to-swap": "Entrez le montant \xE0 \xE9changer",
  "widgets.swap-form.swap-button.no-liquidity-for-swap": "Pas de liquidit\xE9 pour l'\xE9change",
  "widgets.swap-form.swap-button.insufficient-balance": "Solde insuffisant de {{symbol}}",
  "widgets.swap-form.swap-button.set-max": "D\xE9finir le max {{symbol}}",
  "widgets.swap-form.swap-button.wait-wallet-response": "Attendre la r\xE9ponse du portefeuille",
  "widgets.swap-form.swap-button.permit-swap-in-wallet": "Permettre l'\xE9change dans le portefeuille",
  "widgets.swap-form.swap-button.allow-swap-in-wallet": "Autoriser l'\xE9change dans le portefeuille",
  "widgets.swap-form.swap-button.wallet-rejected": "Le portefeuille a rejet\xE9 la demande",
  "widgets.swap-form.swap-button.swap-error-message": "Erreur d'\xE9change",
  "widgets.swap-form.swap-button.waiting-approve-transaction": "En attente de l'approbation du jeton"
};
export {
  fr_default as default
};
//# sourceMappingURL=fr-CR6ZYPHE.js.map
